import { render, staticRenderFns } from "./RecentOrders.vue?vue&type=template&id=4abeccbe&scoped=true&"
import script from "./RecentOrders.vue?vue&type=script&lang=js&"
export * from "./RecentOrders.vue?vue&type=script&lang=js&"
import style0 from "./RecentOrders.vue?vue&type=style&index=0&id=4abeccbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abeccbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VPagination,VRow})
